import React from 'react';
import { Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
const ClaimGroupSelector = _ref => {
  let {
    accountType,
    loading,
    company,
    claimGroup,
    allClaimGroups
  } = _ref;
  const history = useHistory();
  const handleClaimGroupChange = async e => {
    if (accountType === 'customer' && process.env.PUBLIC_URL === '/be') {
      return history.push(`/${accountType}/claim_groups/${e.target.value}/claim_group_dashboard`);
    } else {
      return history.push(`/${accountType}/companies/${company.id}/${e.target.value}/master`);
    }
  };
  const getClaimGroupOptions = () => {
    const sortedClaimGroupYears = allClaimGroups.sort((a, b) => a.name.slice(-4) > b.name.slice(-4) ? -1 : 1);
    return sortedClaimGroupYears.map(claimGroup => {
      return /*#__PURE__*/React.createElement("option", {
        value: claimGroup.id
      }, claimGroup.name.replace(company.name, '').trim());
    });
  };
  if (!claimGroup) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "mx-2 my-3"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    value: claimGroup.id,
    onChange: handleClaimGroupChange,
    name: "current_claim_group",
    as: "select",
    size: "md",
    className: "p-1 "
  }, !loading && getClaimGroupOptions()));
};
export default ClaimGroupSelector;